import { AsyncPipe, CurrencyPipe, DatePipe, DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { DisplayLabelPipe, PriceScalePipe } from '@zero/shared/ui-pipes';
import { IconComponent } from '@zero/shared/ui-web-design-system';
import {
  CombinedFractionalOrderValuePipe,
  CombinedMarketOrderValuePipe,
  CombinedOrderSumPipe,
  DynamicQuantityPipe,
  TradeConfirmDataBase,
} from '@zero/trade/feature-trade/base';

@Component({
  selector: 'trade-confirm-data',
  templateUrl: './trade-confirm-data.component.html',
  styleUrls: ['./trade-confirm-data.component.scss'],
  imports: [
    BlinkDirective,
    AsyncPipe,
    DecimalPipe,
    CurrencyPipe,
    DatePipe,
    TranslocoPipe,
    DisplayLabelPipe,
    PriceScalePipe,
    NgTemplateOutlet,
    IconComponent,
    NgTemplateOutlet,
    NgbTooltipModule,
    CombinedMarketOrderValuePipe,
    CombinedFractionalOrderValuePipe,
    DynamicQuantityPipe,
    CombinedOrderSumPipe,
  ],
})
export class TradeConfirmDataComponent extends TradeConfirmDataBase {}
